import { motion } from 'framer-motion'
import PortfolioManagement from '../Settings'

const SettingsPage: React.FC = () => {
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  }

  return (
    <motion.div variants={itemVariants}>
      <PortfolioManagement />
    </motion.div>
  )
}

export default SettingsPage